import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=1a9a182a&scoped=true"
var script = {}
import style0 from "./Twitter.vue?vue&type=style&index=0&id=1a9a182a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a182a",
  null
  
)

export default component.exports